import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { AssignedTracksList } from "../AssignedTracks/AssignedTracksList";

import projectSettings from "../../assets/Js/projectSettings";
import { getPlainToken } from "../../assets/Js/tokenHandler";
import { callAPI } from "../../assets/Js/backendCommunication";
import { withReduxData } from "../../HOC/withReduxData";
import { immediateToast } from "izitoast-react";
import { roleEnum } from "../../assets/Js/roleEnum";

const AtheleteDetails = ({
  athleteId,
  gymData,
  loggedInUserRole,
  desiredRole,
}) => {
  const [athleteData, setAthleteData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const athleteIdRef = useRef();

  useEffect(() => {
    if (loggedInUserRole === roleEnum.owner && gymData.length && athleteId) {
      getAthletesInformation({
        userId: athleteId,
        gymId: gymData[0]?.Id,
      });
    } else if (
      loggedInUserRole === roleEnum.athlete &&
      athleteId !== athleteIdRef.current
    ) {
      recentJoinedTrack();
    }

    athleteIdRef.current = athleteId;
  }, [athleteId, gymData]);

  const getAthletesInformation = async ({ userId, gymId }) => {
    let url = `${projectSettings.baseUrl}/tracks/getusertracks/${gymId}/${userId}`;
    let header = false;
    let data = null;
    let type = "GET";
    let token = getPlainToken();

    let response = "";

    setIsLoading(true);

    response = await callAPI(url, header, type, data, token);

    if (response) {
      setIsLoading(false);

      let data = response?.data;

      if (response.data.StatusCode === 200) {
        setAthleteData(data?.Result);
      } else {
        data?.Errors?.length &&
          immediateToast("warning", { message: data.Errors[0] });
      }
    }
  };

  const recentJoinedTrack = async () => {
    let url = `${projectSettings.baseUrl}/GymStats/RecentJoinedTracks`;
    let header = false;
    let data = null;
    let type = "GET";
    let token = getPlainToken();

    let response = "";

    setIsLoading(true);

    response = await callAPI(url, header, type, data, token);

    if (response) {
      setIsLoading(false);

      let data = response?.data;

      if (response.data.StatusCode === 200) {
        setAthleteData(data?.Result);
      } else {
        data?.Errors?.length &&
          immediateToast("warning", { message: data.Errors[0] });
      }
    }
  };

  return (
    <div className={`colorBglite`}>
      <div className="colorBgWhite shadow-sm">
        <>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card p-0 mb-0">
              <div class="card border-0">
                <div class="card-body dashboard-tabs p-0">
                  <div class="tab-content py-0 px-0">
                    <div
                      class="tab-pane fade show active"
                      id="access"
                      role="tabpanel"
                      aria-labelledby="access-tab"
                    >
                      <AssignedTracksList
                        userId={athleteId}
                        athleteData={athleteData}
                        loggedInUserRole={loggedInUserRole}
                        desiredRole={desiredRole}
                        isLoading={isLoading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default withReduxData(AtheleteDetails);

AtheleteDetails.propTypes = {
  athleteId: PropTypes.string,
  gymData: PropTypes.array,
  loggedInUserRole: PropTypes.string,
  desiredRole: PropTypes.string,
};
